import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { gaps } from 'components/layout/stack';
import ContactForm from 'components/user/contact_form';
import HeaderBar from 'components/header_bar';
import { observer } from 'mobx-react';
import React from 'react';

const Wrapper = styled.div`
  width: 100%;
`;

const Content = styled.div`
  width: 100%;
  padding: 10px 0 0 0;
`;

const Panel = styled.div`
  padding: ${gaps.lg};
  background: #FFF;
  border-radius: 10px;
  border: 1px solid #dedede;
`;

const Heading = styled.h3`
  margin: 0 0 10px 0;
`;

const Paragraph = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 26px;
`;

const EmailLink = styled.a`
  color: ${() => AppUI.site.accentColor};
  text-decoration: underline;
`;

@observer
class ContactMemrev extends React.Component {

  render() {
    return (
      <Wrapper>
        <HeaderBar
          title='Contact Us'
          titleRoute='contact'
          margin='0'
        />
        <Content>
          <Panel>
            <Heading>
              Questions about your membership or our platform?
            </Heading>
            <Paragraph>
              The fastest way to reach us is through this contact form, but you can also email us at <EmailLink href='mailto:memberships@easy-languages.org'>memberships@easy-languages.org</EmailLink>. We usually reply within 48 hours.
            </Paragraph>
            <ContactForm
              {...this.props}
            />
          </Panel>
        </Content>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(ContactMemrev);
